import { Match } from "effect";
import { INTERNAL_HTTP_MESSAGE } from "@workerstation/shared/errors/http";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";

export const kvFailureMessage = (error: ResourceFailure): string => Match.value(error).pipe(
  Match.tag("ResourceRequestError", failure => failure.message),
  Match.tag("ResourceStorageError", () => INTERNAL_HTTP_MESSAGE),
  Match.exhaustive
);
